module.exports = __webpack_public_path__ + "static/fonts/PingFang.46f8336.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/common/less/PingFang.ttf
// module id = pEMQ
// module chunks = 106